import React, { useCallback, useRef } from 'react';
import { Map } from 'immutable';

import isFunction from '../../utils/isFunction';
import { PrettyErrorProvider } from '../../contexts/PrettyErrorContext';

const defaultInputErrors = Map();

const InputErrorDisplayDecorator = (onErrorCloseName = 'onErrorClose', field = 'inputError', Component) => {
  if (Component === undefined && field === 'inputError') {
    return InputErrorDisplayDecorator(undefined, undefined, onErrorCloseName);
  }
  if (!isFunction(onErrorCloseName) && typeof onErrorCloseName !== 'string') {
    throw new Error("InputErrorDisplayDecorator's first argument should be a function of prop name.");
  } else if (Component === undefined) return InputErrorDisplayDecorator(onErrorCloseName, undefined, field);

  const InputErrorDisplay = props => {
    const propsRef = useRef(props);

    propsRef.current = props;

    const defaultOnError = useCallback((event, errorField) => {
      propsRef.current[onErrorCloseName]({ field: errorField });
    }, []);

    const onErrorClose = isFunction(onErrorCloseName) ? onErrorCloseName : defaultOnError;
    const inputErrors = props.inputErrors || defaultInputErrors;

    return (
      <PrettyErrorProvider inputErrors={inputErrors} onErrorClose={onErrorClose}>
        <Component {...props} />
      </PrettyErrorProvider>
    );
  };

  InputErrorDisplay.displayName = `InputErrorDisplay(${Component.displayName || Component.name})`;

  return InputErrorDisplay;
};

export default InputErrorDisplayDecorator;
